import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormState {
  isAlternateSubmitting: boolean;
  isAlternateValid: boolean;
  formAlternateData: any;
}

const initialState: FormState = {
  isAlternateSubmitting: false,
  isAlternateValid: true,
  formAlternateData: {},
};

const formContactAlternateSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    triggerAlternateSubmit: (state) => {
      state.isAlternateSubmitting = true;
    },
    setFormAlternateValidity: (state, action: PayloadAction<{ isValid: boolean; formData: any }>) => {
      state.isAlternateValid = action.payload.isValid;
      state.formAlternateData = action.payload.formData;
      state.isAlternateSubmitting = false; 
    },

    resetFormAlternateData: (state) => {
      state.isAlternateSubmitting = false;
      state.isAlternateValid = true;
      state.formAlternateData = {};
    },
  },
});

export const { triggerAlternateSubmit, setFormAlternateValidity, resetFormAlternateData } = formContactAlternateSlice.actions;
export default formContactAlternateSlice.reducer;
